import {
  Autocomplete,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Grid2,
  Slider,
  TextField,
  Typography,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import React, { Fragment } from "react";
import XCloseIco from "../../../../../assets/icons/XCloseIco";
import CommonButton from "../../../../../component/Button";
import CommonTextField from "../../../../../component/Input";
import DropDownSelect from "../../../../../component/Select";
import { CommonGrid2 } from "../../../../common-components/StyledComponents";
import { CustomizeSpan, ErrorContent } from "../../../../jobs/style";
import { AutocompleteText } from "../../../../../component/AutoComplete";
import { CustomDiv } from "../../../../chat-bot/style";
import { HandleSkeletion } from "../../../../../utils/constants";
import CommonPhoneInput from "../../../../../component/PhoneInput";

export default function CreateRecord({
  contact,
  title,
  contactData,
  handleButttonClose,
  validationSchema,
  initialValues,
  handleSubmit,
  handleContactClose,
}) {
  return (
    <Dialog
      fullWidth
      maxWidth={"md"}
      open={contact.open}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "10px",
        },
      }}
    >
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Typography
          variant="h3"
          textAlign={"center"}
          margin={"1rem 0px 0px 1rem"}
        >
          {title}
        </Typography>
        <Button onClick={handleButttonClose}>
          <XCloseIco />
        </Button>
      </DialogActions>

      <DialogContent style={{ textAlign: "center", paddingTop: "0px" }}>
        <Formik
          key={contact.open}
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnChange={true}
          validateOnBlur={false}
          onSubmit={(values, actions) => {
            actions.validateForm().then(() => {
              handleSubmit(values);
            });
          }}
        >
          {({
            values,
            handleChange,
            setFieldValue,
            errors,
            touched,
            submitCount,
          }) => {
            return (
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
              >
                <Grid2 spacing={2} container size={12} marginTop={"1.5rem"}>
                  {contactData?.map((item, fieldIndex) => {
                    return (
                      <Grid2 key={fieldIndex} size={{ xs: 12, md: 6, sm: 6 }}>
                        {values.loading ? (
                          <HandleSkeletion height={60} transform="scale(1)" />
                        ) : (
                          <CommonGrid2
                            display={"flex"}
                            gap={item.title === "Rating" ? "3px" : "10px"}
                            flexDirection={"column"}
                            textAlign={"left"}
                          >
                            <Fragment>
                              <Typography
                                variant="h6"
                                fontSize={"16px"}
                                color={"#344054"}
                              >
                                {item.title}
                                {item.mandatory && (
                                  <CustomizeSpan color={"red"}>*</CustomizeSpan>
                                )}
                              </Typography>

                              {item.component === "input" && (
                                <Field name={item.titleName}>
                                  {({ field, form }) => {
                                    const showError =
                                      submitCount > 0 &&
                                      form.errors[item.titleName];
                                    return (
                                      <CommonTextField
                                        {...field}
                                        placeholder={item?.placeholder}
                                        padding="10px"
                                        {...field}
                                        error={showError}
                                        helperText={
                                          showError
                                            ? form.errors[item.titleName]
                                            : ""
                                        }
                                        placeholderFontSize={
                                          item?.placeholderFontSize
                                        }
                                        value={values[item.titleName]}
                                        onChange={(e) => {
                                          setFieldValue(
                                            item.titleName,
                                            e.target.value
                                          );
                                        }}
                                      />
                                    );
                                  }}
                                </Field>
                              )}
                              {item.component === "dropDown" && (
                                <Field name={item.titleName}>
                                  {({ field, form }) => {
                                    const showError =
                                      submitCount > 0 &&
                                      form.errors[item.titleName];

                                    return (
                                      <DropDownSelect
                                        marginTop="0px"
                                        title={
                                          item?.placeholder
                                            ? item?.placeholder
                                            : item.title
                                        }
                                        disabled={item?.disabled}
                                        removeAnimation={true}
                                        data={form.values[item.dropDownData]}
                                        error={showError}
                                        helperText={
                                          showError
                                            ? form.errors[item.titleName]
                                            : ""
                                        }
                                        value={form.values[item.titleName]}
                                        handleChange={(e) =>
                                          setFieldValue(
                                            item.titleName,
                                            e.target.value
                                          )
                                        }
                                      />
                                    );
                                  }}
                                </Field>
                              )}

                              {item.component === "single-auto-complete" && (
                                <Field name={item.titleName}>
                                  {({ field, form }) => {
                                    const showError =
                                      submitCount > 0 &&
                                      Boolean(form.errors[item.titleName]);
                                    return (
                                      <Autocomplete
                                        disablePortal
                                        getOptionLabel={(option) => option.name}
                                        options={values[item.dropDownData]}
                                        value={
                                          values[item.titleName]
                                            ? values[item.dropDownData].find(
                                                (option) =>
                                                  option.name ===
                                                  values[item.titleName]
                                              ) || null
                                            : null
                                        }
                                        renderInput={(params) => {
                                          return (
                                            <TextField
                                              {...params}
                                              placeholder={item.placeholder}
                                              InputLabelProps={{
                                                shrink: false,
                                              }}
                                              sx={{
                                                "& input::placeholder": {
                                                  color: "text.secondary",
                                                  opacity: 0.8, // IMPORTANT: MUI defaults placeholder opacity to 0.42
                                                },
                                              }}
                                              error={showError}
                                              helperText={
                                                showError
                                                  ? form.errors[item.titleName]
                                                  : ""
                                              }
                                            />
                                          );
                                        }}
                                        onChange={(event, newValue) => {
                                          if (newValue) {
                                            form.setFieldValue(
                                              item.titleName,
                                              newValue.name
                                            );
                                          } else {
                                            form.setFieldValue(
                                              item.titleName,
                                              null
                                            );
                                          }
                                        }}
                                        ListboxProps={{
                                          id: "sigle-autocomplete-list",
                                        }}
                                        sx={{
                                          "& input": {
                                            fontSize: "15px",
                                          },
                                          "& .MuiInputBase-root": {
                                            padding: "5px",
                                          },
                                          "& fieldset": {
                                            border: "1px solid #D0D5DD",
                                            borderRadius: "6px",
                                          },

                                          "& label": {
                                            top: "-4px",
                                          },
                                          "& label.MuiInputLabel-shrink": {
                                            top: "0px",
                                          },
                                          "& .Mui-error": {
                                            margin: "2px 0px 0px",
                                            fontWeight: 600,
                                            color: "#d32f2f",
                                          },
                                        }}
                                      />
                                    );
                                  }}
                                </Field>
                              )}

                              {item.component === "multi-complete" && (
                                <Field name={item.titleName}>
                                  {({ form }) => {
                                    const selectedValues = Array.isArray(
                                      values[item.titleName]
                                    )
                                      ? values[item.titleName]
                                      : [];

                                    const options = Array.isArray(
                                      values[item.options]
                                    )
                                      ? values[item.options]
                                      : [];

                                    const showError =
                                      submitCount > 0 &&
                                      Boolean(errors[item.titleName]);

                                    return (
                                      <CustomDiv>
                                        <Autocomplete
                                          multiple
                                          options={options}
                                          getOptionLabel={(option) =>
                                            option.name || ""
                                          }
                                          value={options.filter((opt) =>
                                            selectedValues.some(
                                              (sel) => sel.id === opt.id
                                            )
                                          )}
                                          onChange={(e, newValue) =>
                                            setFieldValue(
                                              item.titleName,
                                              newValue
                                            )
                                          }
                                          limitTags={2}
                                          renderOption={(
                                            props,
                                            option,
                                            { selected }
                                          ) => (
                                            <li
                                              {...props}
                                              style={{ padding: "3px 10px" }}
                                            >
                                              <Checkbox checked={selected} />
                                              {option.name}
                                            </li>
                                          )}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              placeholder={item.placeholder}
                                              error={showError}
                                              ListboxProps={{
                                                id: "custom-autocomplete-list",
                                              }}
                                              disablePortal
                                              disableCloseOnSelect
                                              sx={{
                                                "& label.MuiInputLabel-sizeMedium":
                                                  {
                                                    top: "-5px !important",
                                                  },
                                                "& label.MuiInputLabel-shrink":
                                                  {
                                                    top: "0px !important",
                                                  },
                                                "& .MuiInputBase-formControl": {
                                                  padding: "5px 39px 5px 9px",
                                                  gap: "4px",
                                                },
                                                "& fieldset": {
                                                  border: "1px solid #D0D5DD",
                                                },
                                                "& .MuiAutocomplete-tag": {
                                                  gap: "5px",
                                                  margin: "0px 3px",
                                                  borderRadius: "5px",
                                                  fontSize: "12px",
                                                  border: "1px solid",
                                                  padding: "2px 6px",
                                                  background:
                                                    "rgba(0, 0, 0, 0.08)",
                                                },
                                              }}
                                            />
                                          )}
                                        />

                                        {showError && (
                                          <ErrorContent>
                                            {errors[item.titleName]}
                                          </ErrorContent>
                                        )}
                                      </CustomDiv>
                                    );
                                  }}
                                </Field>
                              )}

                              {item.component === "autoComplete" && (
                                <Field name={item.titleName}>
                                  {({ field, form }) => {
                                    const handleAutoCompleteChange = (
                                      e,
                                      newValue
                                    ) => {
                                      if (
                                        e?.key === "Backspace" &&
                                        e.target.value === ""
                                      ) {
                                        const updatedValue = [
                                          ...(form.values[item.titleName] ||
                                            []),
                                        ];
                                        updatedValue.pop();
                                        form.setFieldValue(
                                          item.titleName,
                                          updatedValue
                                        );
                                      } else {
                                        const formattedValues = newValue.map(
                                          (item, index) => {
                                            if (typeof item === "string") {
                                              return {
                                                content: item,
                                              };
                                            }
                                            return item;
                                          }
                                        );

                                        form.setFieldValue(
                                          item.titleName,
                                          formattedValues
                                        );
                                      }
                                    };

                                    const handleDelete = (option) => {
                                      const updatedValue = form.values[
                                        item.titleName
                                      ].filter((item, i) => item !== option);
                                      form.setFieldValue(
                                        item.titleName,
                                        updatedValue
                                      );
                                    };

                                    const isError =
                                      submitCount > 0 &&
                                      Boolean(form.errors[item.titleName]);
                                    const helperText = isError
                                      ? form.errors[item.titleName]
                                      : "";

                                    const handleKeyDown = (e) => {
                                      const checkData =
                                        form?.values[item.titleName];
                                      const dataValue = e.target.value;
                                      if (e.key === "Tab") {
                                        e.preventDefault();

                                        if (dataValue !== "") {
                                          const data = {
                                            content: dataValue,
                                          };

                                          const formattedValues = [
                                            ...checkData,
                                            data,
                                          ];
                                          form.setFieldValue(
                                            item.titleName,
                                            formattedValues
                                          );
                                          form.setFieldValue(
                                            item.inputValue,
                                            ""
                                          );
                                        }
                                      }
                                    };

                                    return (
                                      <CustomDiv>
                                        <AutocompleteText
                                          autoData={{
                                            options: [],
                                            key: `autocomplete-${fieldIndex}`,
                                            title: "Select Emails",
                                            placeholder: item.placeholder,
                                            // isDisabled: false,
                                            value: values[item.titleName] || "",
                                            onDelete: handleDelete,
                                            onKeyDown: handleKeyDown,
                                            onChange: handleAutoCompleteChange,
                                            inputValue: values[item.inputValue],
                                            onInputChange: (e, newValue) => {
                                              setFieldValue(
                                                item.inputValue,
                                                newValue
                                              );
                                            },
                                            isDisabled: item?.disabled,
                                            customClass: item.titleName,
                                          }}
                                          error={isError}
                                        />
                                        {isError && (
                                          <ErrorContent margin="2px 0px 0px">
                                            {helperText}
                                          </ErrorContent>
                                        )}
                                      </CustomDiv>
                                    );
                                  }}
                                </Field>
                              )}

                              {item.component === "slider" && (
                                <Field name={item.titleName}>
                                  {({ field, form }) => {
                                    return (
                                      <Slider
                                        min={0}
                                        max={5}
                                        step={0.1}
                                        value={values[item.titleName]}
                                        valueLabelDisplay="auto"
                                        onChange={(_, newValue) =>
                                          setFieldValue(
                                            item.titleName,
                                            newValue
                                          )
                                        }
                                        sx={{
                                          height: "7px",
                                          "& .MuiSlider-rail": {
                                            backgroundColor: "#d1d2d4",
                                          },
                                          "& .MuiSlider-thumb": {
                                            width: 22,
                                            height: 22,
                                            backgroundColor: "#fff",
                                            border: "2px solid #7F56D9",
                                          },
                                          "& .MuiSlider-valueLabel": {
                                            backgroundColor: "#6941C6",
                                            fontSize: "13px",
                                            color: "white",
                                          },
                                        }}
                                      />
                                    );
                                  }}
                                </Field>
                              )}
                              {item.component === "phone-number" && (
                                <Field name={item.titleName}>
                                  {({ field, form }) => {
                                    const showError =
                                      submitCount > 0 &&
                                      Boolean(form.errors[item.titleName]);

                                    return (
                                      <>
                                        <CommonPhoneInput
                                          placeholder={item?.placeholder}
                                          padding="14px 0px 14px 60px"
                                          country="us"
                                          value={values[item.titleName]}
                                          onChange={(e, countryData) => {
                                            setFieldValue(
                                              item.country,
                                              countryData
                                            );
                                            setFieldValue(item.titleName, e);
                                          }}
                                        />
                                        {showError && (
                                          <ErrorContent>
                                            {form.errors[item.titleName]}
                                          </ErrorContent>
                                        )}
                                      </>
                                    );
                                  }}
                                </Field>
                              )}
                            </Fragment>
                          </CommonGrid2>
                        )}
                      </Grid2>
                    );
                  })}
                </Grid2>

                <CommonGrid2
                  display={"flex"}
                  gap={"1rem"}
                  flexWrap={"wrap"}
                  justifyContent={"end"}
                  marginTop={"1.5rem"}
                >
                  <CommonButton
                    value={"Cancel"}
                    width="max-content"
                    variant="outlined"
                    fontWeight={"700"}
                    color="#344054"
                    border="#D0D5DD"
                    padding="10px 1.5rem"
                    onClick={handleContactClose}
                    disabled={contact.disabled || values.loading}
                    loading={contact.cancelLoading}
                  />
                  <CommonButton
                    value={"Create"}
                    width="max-content"
                    padding="10px 1.5rem"
                    type="submit"
                    disabled={contact.disabled || values.loading}
                    loading={contact.createLoading}
                  />
                </CommonGrid2>
              </Form>
            );
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}
